import { useRef } from "react";
import SectionTitle from "../SectionTitle";
import { StyledCampaignSummary } from "./index.styled";
import CampaignSummaryFilter from "./CampaignSummaryFilter";
import CampaignSummaryCard from "./CampaignSummaryCard";
import CampaignSummarySkeleton from "./CampaignSummarySkeleton";
import NoDataFound from "./NoDataFound";
import { downloadCampaignSummaryAsImage } from "../../../utils/downloadUtils";
import { useCampaignSummaryFilter } from "../../../hooks/useCampaignSummaryFilter";
import { useDashboardFilter } from "../../../contexts/DashboardFilterContext";

const CampaignSummary = () => {
  const { activeFilter, selectedMonth, setActiveFilter, setSelectedMonth } =
    useDashboardFilter();
  const cardRef = useRef<HTMLDivElement>(null);
  const { options, loading, hasData } = useCampaignSummaryFilter({
    activeFilter,
    selectedMonth,
  });

  const handleDownload = () => {
    if (cardRef.current) {
      downloadCampaignSummaryAsImage(cardRef.current);
    }
  };

  // Show skeleton loader while data is being fetched
  if (loading) {
    return (
      <StyledCampaignSummary>
        <SectionTitle title="סיכום קמפיינים" />
        <CampaignSummarySkeleton />
      </StyledCampaignSummary>
    );
  }

  return (
    <StyledCampaignSummary>
      <SectionTitle
        title="סיכום קמפיינים"
        hasDownload={hasData}
        onDownload={handleDownload}
      />
      <CampaignSummaryFilter
        activeFilter={activeFilter}
        selectedMonth={selectedMonth}
        onFilterChange={setActiveFilter}
        onMonthChange={setSelectedMonth}
      />
      {hasData ? (
        <CampaignSummaryCard ref={cardRef} options={options} />
      ) : (
        <NoDataFound />
      )}
    </StyledCampaignSummary>
  );
};

export default CampaignSummary;
